// Initialize TikTok pixel early when page loads
(function initTikTokEarly() {
  if (typeof window !== 'undefined' && !window.ttq) {
    console.log('🎵 Early TikTok pixel initialization...');
    
    !function (w, d, t) {
      w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{}};
      ttq.load('C2LDHICST061L8G6PMJ0');
      ttq.page();
      console.log('🎵 Early TikTok pixel setup completed');
    }(window, document, 'ttq');
    
    // Load script immediately
    const script = document.createElement('script');
    script.src = 'https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=C2LDHICST061L8G6PMJ0&lib=ttq';
    script.async = true;
    script.onload = () => console.log('🎵 Early TikTok script loaded');
    script.onerror = () => console.error('🎵 Early TikTok script failed to load');
    document.head.appendChild(script);
  }
})();

function createInsiderTag() {
  const script = document.createElement('script');
  script.src = '//vitable.api.useinsider.com/ins.js?id=10007631';
  script.async = true;
  script.type = 'text/javascript';

  document.head.appendChild(script);
};

function uid() {
  try { return crypto.randomUUID(); }
  catch(e){ return 'quiz-' + Date.now() + '-' + Math.random().toString(36).slice(2); }
}

function loadTikTokPixel() {
  console.log('🎵 Checking TikTok pixel status...');
  
  if (window.ttq && typeof window.ttq.track === 'function') {
    console.log('🎵 TikTok pixel already loaded and ready');
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    console.log('🎵 TikTok pixel not ready, waiting...');
    
    // Wait for up to 5 seconds for TikTok to load
    let attempts = 0;
    const maxAttempts = 50; // 5 seconds
    
    const checkInterval = setInterval(() => {
      attempts++;
      
      if (window.ttq && typeof window.ttq.track === 'function') {
        clearInterval(checkInterval);
        console.log('🎵 TikTok pixel loaded successfully after', attempts * 100, 'ms');
        resolve();
        return;
      }
      
      if (attempts >= maxAttempts) {
        clearInterval(checkInterval);
        console.warn('🎵 TikTok pixel failed to load within timeout');
        reject(new Error('TikTok pixel load timeout'));
      }
    }, 100);
  });
}

function analyticsSubmitQuiz() {
  console.log('📊 Firing analytics for quiz submission');
  (function fireGA4(){
    if (typeof gtag !== "function") return;
    gtag('event', 'submit_quiz', {});
  })();

  (function fireMeta(){
    if (typeof fbq !== "function") return;
    fbq('track', 'Lead', {}, { eventID: uid() });
  })();

  (function fireTikTok(){
    console.log('🎵 Starting TikTok tracking...');
    
    try {
      // Check if ttq object exists
      if (!window.ttq) {
        console.warn('🎵 TikTok ttq object not available');
        return;
      }
      
      // Check if track method exists and is a function
      if (typeof window.ttq.track !== "function") {
        console.warn('🎵 TikTok ttq.track method not available, type:', typeof window.ttq.track);
        return;
      }
      
      window.ttq.track('SubmitForm', {
        content_type: 'quiz_submission',
        description: 'Quiz completion lead event'
      });
      console.log('🎵 TikTok SubmitForm event fired successfully');
    } catch (err) {
      console.error('[TikTok] SubmitForm tracking failed:', err);
    }
  })();
};

function loadInsiderUser(email, firstName) {
  window.insider_object.user = {
    uuid: '',
    email,
    name: firstName,
    surname: '',
    custom: { user_id: '', test_multi_1: { recommended: true, current_order: false } },
    username: email,
    gdpr_optin: true,
    email_optin: true
  };

  createInsiderTag();
}

document.addEventListener('octane.quiz.completed', function (e) {
  console.log('✅ Octane quiz completed event fired');
  console.log('🔍 Full event payload:', e.detail);

  // Extract allergy & pregnancy
  const quizAnswers = e.detail.answers || {};
  const allergy = quizAnswers.allergy;
  const pregnancy = quizAnswers.pregnancy;
  let firstName = quizAnswers.first_name;
  let email = e.detail.email;

  if (window?.__vitableCustomer) {
    firstName = window?.__vitableCustomer?.firstName || firstName;
    email = window?.__vitableCustomer?.email || email;
  }

  // Local storage keys
  const PREGNANCY_KEY = 'vitable_pregnancy';
  const ALLERGY_KEY = 'vitable_allergy';
  const NAME_ON_PACK_KEY = 'vitable_name_on_pack';
  const QUIZ_DATE_KEY = 'vitable_latest_quiz_date';

  // Handle storage set/remove
  if (pregnancy && typeof pregnancy === 'string' && pregnancy !== '') {
    localStorage.setItem(PREGNANCY_KEY, pregnancy);
    console.log(`[Quiz Sync] Stored pregnancy: ${pregnancy}`);
  } else {
    localStorage.removeItem(PREGNANCY_KEY);
    localStorage.removeItem(QUIZ_DATE_KEY);
    console.log('[Quiz Sync] Cleared pregnancy (empty or missing)');
  }

  if (allergy && typeof allergy === 'string' && allergy !== '') {
    localStorage.setItem(ALLERGY_KEY, allergy);
    console.log(`[Quiz Sync] Stored allergy: ${allergy}`);
  } else {
    localStorage.removeItem(ALLERGY_KEY);
    localStorage.removeItem(QUIZ_DATE_KEY);
    console.log('[Quiz Sync] Cleared allergy (empty or missing)');
  }
  
  if (firstName && typeof firstName === 'string' && firstName !== '') {
    localStorage.setItem(NAME_ON_PACK_KEY, firstName);
    console.log(`[Quiz Sync] Stored name_on_pack: ${firstName}`);
  } else {
    localStorage.removeItem(NAME_ON_PACK_KEY);
    localStorage.removeItem(QUIZ_DATE_KEY);
    console.log('[Quiz Sync] Cleared name_on_pack (empty or missing)');
  }
  
  // Store the quiz completion timestamp
  localStorage.setItem(QUIZ_DATE_KEY, Date.now().toString());
  console.log(`[Quiz Sync] Stored latest quiz date: ${new Date().toISOString()}`);

  // De-dupe: ensure we only send once per page load
  if (!window.__vitableQuizSubmitted) {
    window.__vitableQuizSubmitted = true;

    // Load TikTok pixel and wait for it to initialize before firing analytics
    loadTikTokPixel()
      .then(() => {
        console.log('🎵 TikTok pixel ready, firing analytics...');
        analyticsSubmitQuiz();
      })
      .catch((err) => {
        console.warn('🎵 TikTok pixel failed to load, firing analytics anyway:', err);
        analyticsSubmitQuiz();
      });

    loadInsiderUser(email, firstName);
    
    try {
      if (window.Insider && typeof window.Insider.track === 'function') {
        function pad(n) {
          return n < 10 ? '0' + n : n;
        }

        function isoDateString(d) {
          return d.getUTCFullYear() + '-' +
            pad(d.getUTCMonth() + 1) + '-' +
            pad(d.getUTCDate()) + 'T' +
            pad(d.getUTCHours()) + ':' +
            pad(d.getUTCMinutes()) + ':' +
            pad(d.getUTCSeconds()) + 'Z'
        }

        const { Insider } = window;
        Insider.eventManager.dispatch('init-manager:re-initialize');

        window.Insider.track('events', [{
          event_name: 'quiz_submitted',
          timestamp: isoDateString(new  Date()),
          event_params: {
            custom: {
              event_source: 'quiz_page'
            }
          }
        }]);
        console.debug('[Insider] quiz_submitted event sent');
      }
    } catch (err) {
      console.debug('[insider] quiz_submitted tracking failed (non-blocking)', err);
    }
  }

  let payload = {
    answers: e.detail.answers,
    email: e.detail.email || '',
  };

  if (window?.__vitableCustomer) {
    payload = {
      ...payload,
      isLoggedIn: true,
      customerEmail: window?.__vitableCustomer?.email
    }
  }

  console.log('📦 Sending quiz data to recommendation app:', payload);

  fetch('https://lvi88fhcpg.execute-api.ap-southeast-2.amazonaws.com/prod/recommendation/quiz/submission', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to fetch recommendation token');
      }
      return response.json();
    })
    .then(data => {
      const token = data.token;
      if (!token) throw new Error('Missing recommendation token in response');

      const redirectUrl = `/pages/recommendation?r=${encodeURIComponent(token)}`;
      console.log(`➡️ Redirecting to: ${redirectUrl}`);
      window.location.href = redirectUrl;
    })
    .catch(error => {
      console.error('❌ Error during quiz submission handling:', error);
    });
}, false);

// Quiz Progress Bar Implementation
document.addEventListener('DOMContentLoaded', function () {
  console.log('🔄 Quiz progress bar initialized');
});

// Define anchor questions that will trigger progress updates
const progressAnchors = {
  'ec5a725f4874b8c31a45f3c197ecd00a26a93288': 1, // First bar
  'a99bd022eefe224d9cb62166b3e6ccad752a48d7': 2, // Second bar
  '8ada18b2c9f69f52721e2a012fe516ad94c75a81': 3, // Third bar
  'dfe6d130f55f55795ee8c306056363deae3386c2': 4, // Fourth bar
  '472246be5241dbffacd7ee7af6238452ba1eaafa': 5  // Fifth bar (all bars filled)
};

// Start page ID - hide progress bar when on this page
const startPageId = '80d1b9aa0d582dda9b147256febce694ca8a5c78';

// Define two-column questions that need to maintain columns on mobile
const twoColumnQuestionIds = [
  '1437a88bd566f425abd05821c8a3f091c4d4e9b1',
  '65ce6e55ba1359c31b5f49037de6ae28594d1edd'
];

// Track current position for backward navigation
let currentPosition = 0;

// Listen for question loaded events
document.addEventListener('octane.quiz.questionLoaded', function (event) {
  console.log('🔍 Question loaded:', event?.detail?.question_id);
  const questionId = event?.detail?.question_id;

  // Show/hide progress bar based on whether we're on start page
  const progressContainer = document.querySelector('.quiz-progress-container');
  if (progressContainer) {
    progressContainer.style.display = questionId === startPageId ? 'none' : 'block';
  }
  
  // Apply custom styling to the start page question
  const quizWrapper = document.getElementById('octane-quiz-wrapper');
  if (quizWrapper) {
    // Existing start page styling
    if (questionId === startPageId) {
      quizWrapper.classList.add('start-page-text-style');
      quizWrapper.classList.remove('force-two-columns');
      console.log('🎨 Applied custom styling to start page');
    } 
    // New two-column styling
    else if (twoColumnQuestionIds.includes(questionId)) {
      quizWrapper.classList.remove('start-page-text-style');
      quizWrapper.classList.add('force-two-columns');
      console.log('🎨 Applied two-column layout to question');
    }
    // All other questions
    else {
      quizWrapper.classList.remove('start-page-text-style');
      quizWrapper.classList.remove('force-two-columns');
    }
  }

  // Check if this is an anchor question
  if (progressAnchors[questionId]) {
    const newPosition = progressAnchors[questionId];

    // Check if we're moving backward or forward
    if (newPosition < currentPosition) {
      console.log('⬅️ Moving backward in quiz navigation');
    } else if (newPosition > currentPosition) {
      console.log('➡️ Moving forward in quiz navigation');
    }

    // Update the current position and progress bars
    currentPosition = newPosition;
    updateProgressBars(currentPosition);
  }
}, false);

// Update progress bars based on current stage
function updateProgressBars(stage) {
  console.log('📊 Updating progress to stage:', stage);

  // Update each progress bar
  for (let i = 1; i <= 5; i++) {
    const progressBar = document.getElementById(`progress-bar-${i}`);
    if (progressBar) {
      progressBar.setAttribute('width', i <= stage ? '100' : '0');
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver(() => {
    const checkbox = document.querySelector('input[type="checkbox"][alt*="I agree"]');
    const btn = document.querySelector('button[title="See my results"]');

    if (!checkbox || !btn) return;

    if (checkbox.dataset.listenerAttached === 'true') return;

    console.log('✅ Checkbox for consent found, attaching handler');

    let clickHandler = () => {
      const loading = document.getElementById('quiz-loading');
      if (loading) {
        setTimeout(() => {
          loading.style.display = 'flex';
          console.log('⏳ Showing loading spinner...');
        }, 3500);
      }
    };

    checkbox.addEventListener('change', function () {
      if (checkbox.checked) {
        if (!btn.dataset.loadingAttached) {
          btn.addEventListener('click', clickHandler);
          btn.dataset.loadingAttached = 'true';
          console.log('🔗 Attached loading handler to See My Results');
        }
      } else {
        if (btn.dataset.loadingAttached) {
          btn.removeEventListener('click', clickHandler);
          delete btn.dataset.loadingAttached;
          console.log('🚫 Removed loading handler from See My Results');
        }
      }
    });

    checkbox.dataset.listenerAttached = 'true';
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

// Enforce "None of the above" rule on multiselect questions
(() => {
  const NONE_LABELS = [
    'none','none of the above','neither',
  ].map(s => s.toLowerCase());

  const OPTION_SEL = 'li.oct-quiz-multiple-choice-options__option';
  const GROUP_SEL  = 'ul.oct-quiz-multiple-choice-options';
  const norm = s => (s || '').trim().toLowerCase();

  let suppress = false; // block the loop when I click() myself
  const nextTick = (fn) => setTimeout(fn, 0);

  const getLabel = (li) => {
    const firstDiv = li.querySelector(':scope > div:first-child');
    return norm(firstDiv ? firstDiv.textContent : li.textContent);
  };
  const isSelected = (li) => li.getAttribute('data-is-option-selected') === 'selected';
  const deselect   = (li) => { if (isSelected(li)) { suppress = true; li.click(); suppress = false; } };

  document.addEventListener('click', function (e) {
    if (suppress) return; // ignore clicks generated by the script

    const li = e.target.closest(OPTION_SEL);
    if (!li) return;

    const group = li.closest(GROUP_SEL);
    if (!group) return;

    const label = getLabel(li);
    const isNone = NONE_LABELS.includes(label);
    const items = Array.from(group.querySelectorAll(OPTION_SEL));
    const noneItem = items.find(o => NONE_LABELS.includes(getLabel(o)));

    if (isNone) {
      // Select "None" -> remove all other options, do *after* Octane processes the current click
      nextTick(() => {
        items.forEach(o => { if (o !== li) deselect(o); });
        // Make sure "None" is actually on (user double-clicks very quickly)
        if (!isSelected(li)) { suppress = true; li.click(); suppress = false; }
      });
      return;
    }

    // User selects another option while "None" is on -> turn off "None" on the next tick
    if (noneItem && isSelected(noneItem)) {
      nextTick(() => deselect(noneItem));
    }
  }, true); // capture=true to capture early but main action runs at nextTick

  console.debug('[quiz-none-of-the-above] attached');
})();



